module.exports = __webpack_public_path__ + "static/media/6_ES.0a525a6b.mp3";